module.exports = __webpack_public_path__ + "static/media/selected.28f338ef.svg";